import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { TOKEN_KEY } from "@/lib/api";
import { ROLE_HOME } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        localStorage.setItem(TOKEN_KEY, data.session_token);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(ROLE_HOME[data.user.role] || "/compte", { replace: true, state: { user: data.user } });
        window.location.reload();
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Connexion en cours…</p>
      </div>
    </div>
  );
}
